import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./Home.css";
import Scroll from "./Scroll.jsx";

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Protek Consult | Civil Engineering Consultancy & Architecture in Hyderabad</title>
        <meta name="description" content="Protek Consult is a leading civil engineering consultancy and architecture firm in Hyderabad with 37+ years of expertise. We offer structural engineering, project management consultancy, building permission, layout permission, land surveying, interior design, and energy auditing services." />
        <meta name="keywords" content="civil engineering consultancy Hyderabad, structural engineering services, architecture design services, building permission, layout permission, project management consultancy India, technical due diligence, land surveying services, building valuation services, interior designing Hyderabad, energy auditing services, construction consultants Hyderabad, Protek Consult" />
        <link rel="canonical" href="https://protekconsult.com/" />
      </Helmet>

    <div className="home-section">
      <div className="home-text">
        <h1>
          Structuring 
          the <span className="highlight1">future </span> 
          with precision
        </h1>
        <p>
          We are a leading civil engineering firm providing integrated services in design, structural engineering, and approval due diligence delivering end-to-end solutions for infrastructure and real estate projects.
        </p>
        <div className="home-buttons">
          <button className="primary-btn" onClick={() => navigate("/services")}>
            Our Services
          </button>
          <button className="secondary-btn" onClick={() => navigate("/gallery")}>
            View Projects
          </button>
        </div>
      </div>

      <div className="home-image-container">
        <img src="/Assets/image.png" alt="Protek Consult civil engineering and architecture project in Hyderabad" className="main-image desktop-image" fetchpriority="high" />
        <img src="/Assets/image.png" alt="Protek Consult infrastructure development and structural engineering services" className="main-image mobile-image" fetchpriority="high" />
      </div>
    </div>
    <Scroll />
    </>
  );
};

export default Home;
